import { Link } from 'react-router-dom';
import type { FeedItem } from '@/types/feed';
import Tag from '@/components/base/Tag';
import HeatMeter from '@/components/base/HeatMeter';

interface FeedCardProps {
  item: FeedItem;
  showHeat?: boolean;
}

export default function FeedCard({ item, showHeat = false }: FeedCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors duration-300 hover:border-primary-500/45">
      <Link to={`/article/${item.slug}`} className="flex h-full flex-col">
        <div className="relative h-[188px] w-full overflow-hidden">
          <img
            src={item.image}
            alt={`${item.title} - ${item.category}话题配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
          <span className="absolute left-3 top-3">
            <Tag tone="primary">{item.category}</Tag>
          </span>
          <span className="absolute right-3 top-3">
            <Tag tone="neutral">{item.timeSlot}</Tag>
          </span>
        </div>

        <div className="flex flex-1 flex-col p-4 md:p-5">
          <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-300">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

          <div className="mt-auto pt-4">
            <div className="flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
              <span className="whitespace-nowrap">
                {item.publishedAt} · {item.readMinutes} 分钟
              </span>
              <span className="truncate pl-3 text-right">{item.author}</span>
            </div>
            {showHeat ? (
              <div className="mt-3">
                <HeatMeter value={item.heat} tag={item.stage === '持续发酵' ? '热' : undefined} />
              </div>
            ) : null}
          </div>
        </div>
      </Link>
    </article>
  );
}